import { Block } from 'baseui/block';
import { useGetMatchQuery } from '../../../../services/objects';
import { modelId } from './types'
import { FormattedMessage } from 'react-intl';
import {  useStyletron } from 'baseui';
import { IoIosSnow } from 'react-icons/io';
import { ParagraphSmall } from 'baseui/typography';

const ActiveCoolingGenerators = (props: { parentId: string, parentResourceGroupId: string }) => {
    const [, theme] = useStyletron();
    const { data: active } = useGetMatchQuery({
        objectId: props.parentId,
        resourceGroupId: props.parentResourceGroupId,
        hops: '..2',
        relationship: 'Contains',
        modelId: modelId,
        queryParameters: 'IsOn=true'
    });

    return (<>
        {active && active.length > 0 &&
            <ParagraphSmall margin={0}>
                <Block display={'flex'} gridGap={theme.sizing.scale200} alignItems={'baseline'}>
                    <IoIosSnow color={theme.colors.accent400}></IoIosSnow>
                    <b>{active.length}</b>
                    {active.length === 1 ?
                        <FormattedMessage id="P_CoolingGenerator.CoolingGeneratorON" defaultMessage="Cooling generator ON" />
                        :
                        <FormattedMessage id="P_CoolingGenerator.CoolingGeneratorsON" defaultMessage="Cooling generators ON" />
                    }
                </Block>
            </ParagraphSmall>
        }
    </>)
}

export default ActiveCoolingGenerators;
